import React, { useState } from "react";
import "./faq.css";
import deesPhoto from "../../img/Dee.jpg"; // pas dit pad aan als nodig

const faqs = [
  {
    question: "🎨 Maak je ook beelden op bestelling?",
    answer:
      "Ik maak dát waar ik zelf zin in heb en dus niet op bestelling. Als je iets speciaals zoekt kun je me dat vertellen en misschien inspireert het mij om zoiets te maken 🙂! Natuurlijk kun je ook een workshop plannen en misschien kan je het dan wel zelf maken. 🎨",
  },
  {
    question: "🛒 Hoe kan ik kunst kopen?",
    answer:
      "Mail mij om een afspraak te maken om te komen kijken, of bel me voor meer informatie. 📧📞",
  },
  {
    question: "👀 Waar kan ik je werk bekijken?",
    answer:
      "Ik sta 1x per jaar op het Festival des Arts in Rimburg; gemeente Landgraaf. Dit is altijd op de 1e zondag in Juli. Verder kun je altijd contact met mij opnemen via mail of app en dan kunnen we een afspraak inplannen. 📅✨",
  },
  {
    question: "❓ Geef je ook uitleg bij de workshop?",
    answer: "Ja, ik geef altijd uitleg en begeleiding tijdens de workshop. 👩‍🏫",
  },
  {
    question: "♿ Is het rolstoeltoegankelijk?",
    answer:
      "Ja, de workshopruimte is rolstoeltoegankelijk ♿, alleen het toilet is helaas niet geschikt voor rolstoelen.",
  },
  {
    question:
      "🌦️ Kan ik mijn werkstuk of het kunstwerk dat ik gekocht heb, buiten laten staan?",
    answer:
      "Als dit werkstuk biscuit gebakken is en daarna geglazuurd, dan kan het in de zomer buiten staan ☀️. De keramiek zuigt vocht op en als het dan gaat vriezen is er een groot risico dat het gaat barsten ❄️. Als je werk dat alleen biscuit gebakken is buiten zet (en in de winter binnen) vormt zich mos op het beeld en dit geeft soms een erg mooi effect 🍃. Als een werkstuk hoog gestookt is, kan het wél in de winter buiten blijven, de poriën van de klei zijn dan a.h.w. dicht gesmolten.",
  },
  {
    question: "🧰 Moet ik materiaal meenemen naar de workshop?",
    answer: "Nee, alle benodigde materialen worden door mij verzorgd. 🛠️",
  },
  {
    question: "👶 Voor welke leeftijden is de workshop geschikt?",
    answer:
      "De workshop is geschikt voor alle leeftijden, van kinderen tot senioren. 👶👵",
  },
  {
    question:
      "🍽️ Als ik een gebruiksvoorwerp koop of maak, is dit dan voedselveilig?",
    answer:
      "De meeste glazuur is voedselveilig 🍽️ en het voorwerp kan (meestal) ook gewoon in de afwasmachine. Er zijn een paar soorten glazuur die niet voedselveilig zijn, maar dan kan je het voorwerp wel nog gewoon gebruiken b.v. als fruitschaal 🍉.",
  },
  {
    question: "❌ Wat als ik me wil afmelden voor een workshop?",
    answer:
      "Afmeldingen graag minimaal 48 uur van tevoren doorgeven via e-mail of telefoon. 📅❗",
  },
  {
    question:
      "🔥 Als ik thuis een werkstuk van klei maak, wil jij dat dan voor me bakken?",
    answer:
      "Het lastige met klei is dat het erg gevoelig is voor lucht; als je een laagje klei op je werkstuk plakt, is de kans groot dat er lucht tussen zit 😬. Als je zo'n werkstuk vervolgens samen met andere werkstukken in de oven bakt, kan je werkstuk kapot springen en in het ergste geval neem je nog het werkstuk van een ander in die klap mee! 😢 Ik zeg niet dat dat risico niet aanwezig is als je tijdens een workshop wat maakt, maar ik probeer daar heel goed op te letten zodat de kans dat het gebeurt, klein is. Ik zeg niet dat het mij niet zal gebeuren, maar als je werkstuk door een foutje van een ander sneuvelt, is dat wel heel erg balen! 😞",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <section className="faq-section">
      <div className="faq-content">
        <div className="faq-text">
          <h2>Veelgestelde vragen</h2>
          <div className="faq-list">
            {faqs.map(({ question, answer }, i) => (
              <div key={i} className="faq-item">
                <button
                  onClick={() => toggle(i)}
                  aria-expanded={openIndex === i}
                  aria-controls={`faq-answer-${i}`}
                  id={`faq-question-${i}`}
                  className="faq-question"
                >
                  {question}
                  <span>{openIndex === i ? "−" : "+"}</span>
                </button>
                {openIndex === i && (
                  <div
                    id={`faq-answer-${i}`}
                    role="region"
                    aria-labelledby={`faq-question-${i}`}
                    className="faq-answer"
                  >
                    {answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="faq-image">
          <img src={deesPhoto} alt="Dees Gardeniers" />
        </div>
      </div>
    </section>
  );
}
